import { createTheme } from '@mui/material/styles';

/** Oscuro por defecto: una app de medios se usa de noche.
 *  Los colores de estado son semánticos y se usan igual en toda la aplicación,
 *  para que "verde" signifique siempre lo mismo. */
export const estado = {
  poseido: '#66bb6a',
  mejorable: '#42a5f5',
  enCurso: '#ffa726',
  fallido: '#f44336',
  incierto: '#9e9e9e',
} as const;

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#e5a00d' },
    background: { default: '#101114', paper: '#181a1f' },
    success: { main: estado.poseido },
    info: { main: estado.mejorable },
    warning: { main: estado.enCurso },
    error: { main: estado.fallido },
  },
  shape: { borderRadius: 10 },
  typography: { fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif' },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
  },
});
